// extracted by mini-css-extract-plugin
export default {"container":"PlaylistRedirect_container__D+9K6","background":"PlaylistRedirect_background__Y56VJ","typography":"PlaylistRedirect_typography__ddmb7"};